export enum SettingsCompanionDataEventObjectsEnum {
  FROYO_MANAGE_SOURCES = 'froyo_manage_sources',
  FROYO_CREATE_PLAYBOOK = 'froyo_create_playbook',
  FROYO_SUPPORT_MODE = 'froyo_support_mode',
  BREADCRUMB = 'breadcrumb',
}
